export default __webpack_public_path__ + "static/media/headerlogo.d941c9bb.png";